module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epig"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_xiii",
      "title": "xiii"
    }
  }, [_vm._v("I woke up as the sun was reddening; and that was the one distinct time in my life, the strangest moment of all, when I didn’t know who I was—I was far away from home, haunted and tired … I was halfway across America, at the dividing line between the East of my youth and the West of my future.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—"), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_CAPS"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ACK")]), _vm._v(" "), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_CAPS"
  }, [_vm._v("K")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EROUAC,")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("On the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi-first"
  }, [_vm._v("When I woke, I didn’t know where I was or nothing, but I had a feeling something nice had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—"), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_CAPS"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OCKY")]), _vm._v(" "), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_CAPS"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARCIANO,")]), _vm._v(" the morning after becoming heavyweight champion of the world")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0